/* istanbul ignore file */
import React from 'react';
import { DropDownFilter, BaseFilterProps } from 'framework/list';
import OfficeCodeDropdown from './OfficeCodeDropdown';

const OfficeCodeFilter = ({ source, ...props }: BaseFilterProps & { label: string }) => {
  return (
    <DropDownFilter {...props} source={source}>
      <OfficeCodeDropdown source={source} />
    </DropDownFilter>
  );
};

export default OfficeCodeFilter;
